define('toc-resize',[
  "jquery"
], function ($, globals) {
  $(document).ready(function () {
    $("#navpane ul li a").on("click", function (event) {
      toggle_navpane(event);
    });

    if (document.getElementById("contentSection")) {
      
      //Swipe to change topic
      if ($("body").data("swipe-enabled") === true) {
        var startX = 0;
        var endX = 0;
        var dist = 0;
        var feature_area = document.getElementById("contentSection").parentElement;
        var scrollPosition = 0;
        var zoom = false;

        feature_area.addEventListener("touchstart", function (e) {
          var touchobjstart = e.changedTouches[0];
          startX = parseInt(touchobjstart.clientX);
          scrollPosition = feature_area.scrollLeft;
          zoom = false;

          if (e.touches.length > 1) {
            zoom = true;
          }
        }, false);

        feature_area.addEventListener("touchmove", function (e) {
          var touch = e.changedTouches[0];
          endX = parseInt(touch.clientX);
          dist = endX - startX;
          if (e.touches.length > 1) {
            zoom = true;
          }

          if ((dist > 50 || dist < -50) && zoom === false) {
            $(feature_area).css("left", dist);
          } else {
            $(feature_area).css("left", "");
          }
        }, false);

        feature_area.addEventListener("touchend", function (e) {
          $(feature_area).css("left", "");
          if (scrollPosition === feature_area.scrollLeft) {
            $(feature_area).css("left", "");
            var touchend = e.changedTouches[0];
            endX = parseInt(touchend.clientX);

            // total distance in pixels from user's first touch point to last (when 'touchmove' ends / user lifts finger)
            dist = endX - startX;

            if (e.touches.length > 1) {
              zoom = true;
            }

            // swipe left
            if (dist < -150 && zoom === false) {
              $(".next").trigger("click");
            }
            // swipe right
            else if (dist > 150 && zoom === false) {
              $(".previous").trigger("click");
            }
          }
        }, false);
      }

      //Drag to resize navpane
      var width = 0
      var offset = 0
      var drag_handle = document.getElementById("drag-handle");

      drag_handle.addEventListener("touchstart", function (e) {
        offset = 0;
        width = 0;
        $("#contentSection iframe").hide();
      }, false);

      drag_handle.addEventListener("touchmove", function (e) {
        var touch = e.changedTouches[0];
        width = width + touch.clientX - offset;
        offset = touch.clientX;
        resize_navpane(width);
      }, false);

      drag_handle.addEventListener("touchend", function (e) {
        $("#contentSection iframe").show();
      }, false);

      $(".drag-handle").draggable({
        axis: "x",
        helper: function () {
          return $("<div></div>");
        },
        start: function (event, ui) {
          offset = 0;
          width = 0;
          $("#contentSection iframe").hide();
        },
        stop: function (event, ui) {
          $("#contentSection iframe").show();
        },
        drag: function (event, ui) {
          width = width + ui.offset.left - offset;
          offset = ui.offset.left;
          resize_navpane(width + 50);
        },
        revert: true,
        cursor: "ew-resize"
      });
    }
  });

  function resize_navpane(width) {
    navtabswidth = $("#nav-tabs").width();
    if (width < navtabswidth+140) {
      width = navtabswidth+140
    }

    $("#navpane").attr("style", "width: " + width + "px;");
  }

  function toggle_navpane(event) {
    if($(event.target).closest("li").hasClass("active")) {
      width = $("#nav-tabs").width();

      if (width > 50) {
        $(".nav-text").hide()
        $(".nav-tabs").addClass("narrow-nav")
        $(".nav[role=tablist]>li").addClass("narrow-nav")
      } else {
        $(".nav-text").show()
        $(".nav-tabs").removeClass("narrow-nav")
        $(".nav[role=tablist]>li").removeClass("narrow-nav")

        navpanewidth = $("#navpane").width();
        if (navpanewidth < 330) {
          resize_navpane(330);
        }
      }

    }
  }


});
